module.exports = __webpack_public_path__ + "img/海马.99b61bfb.jpg";